module.exports = __webpack_public_path__ + "static/img/qiandao.36f24967.png";